<template>
  <Head>
    <title>{{ product.title }}</title>
    <meta v-if="!product.active" name="robots" content="noindex"/>
    <meta
        v-if="trField(product, 'meta_description')"
        name="description"
        :content="trField(product, 'meta_description')"/>
    <meta v-if="trField(product, 'meta_keywords')" name="keywords" :content="trField(product, 'meta_keywords')"/>
    <link
        rel="canonical"
        :href="getActiveLanguage() === 'et' ? useRoute('product-et', { product: product.url }) : useRoute('product-ru', { product: product.url_ru })"/>
    <link
        rel="alternate"
        hreflang="et"
        :href="useRoute('product-et', { product: product.url })"
    />
    <link
        rel="alternate"
        hreflang="et"
        :href="useRoute('product-ru', { product: product.url_ru })"
    />
  </Head>
  <ShareModal
      :show-modal="modalVisible"
      :url="shareUrl"
      body="E-Lux%20Kodutehnika%20toode%20&body=Saadan%20sulle%20toote%20vaatamiseks%3A%20"
      @close="modalVisible = false"
  />
  <div v-if="!targetIsVisible" class="bg-white fixed print:hidden top-0 left-0 right-0 z-30 border-b border-b-gray-500">
    <div class="container max-w-screen-1.5xl mx-auto py-2 lg:py-3 px-4 lg:px-8">
      <div class="hidden lg:flex space-x-10">
        <a href="#product" class="pl-4 block font-semibold text-xl leading-6">{{ product.title }}</a>
        <ProductPrice
            v-if="product.active"
            :price-vat="product.price_vat"
            :price-default-vat="product.price_default_vat"
            :discount-start="product.discount_start"
            :discount-end="product.discount_end"
            :good-price="product.good_price"
            :show-installment="false"
        />
      </div>
      <div class="lg:block tabs tabs-bordered lg:pt-2">
        <a
            v-if="
        product.long_description ||
        isLoadbee(product.brand) ||
        isFlixmedia(product.brand) ||
        isEstorecontent(product.brand)"
            href="#description"
            role="tab"
            class="tab link text-base lg:text-lg h-auto !border-white"
        >
          {{ __("Tootja info") }}
        </a>
        <a
            v-if="product.related.length > 0"
            href="#related"
            role="tab"
            class="tab link text-base lg:text-lg h-auto !border-white"
        >
          {{ __("Kokkusobivad tooted") }}
        </a>
        <a
            v-if="product.add_ons.length > 0"
            href="#add-ons"
            role="tab"
            class="tab link text-base lg:text-lg h-auto !border-white"
        >
          {{ __("Lisatarvikud") }}
        </a>
        <a
            v-if="similar.length > 0"
            href="#similar"
            role="tab"
            class="tab link text-base lg:text-lg h-auto !border-white"
        >
          {{ __("Sarnased tooted") }}
        </a>
      </div>
    </div>
  </div>
  <ProductCompares/>
  <section class="bg-gray-50 print:hidden">
    <div
        v-if="category && category.id"
        class="container max-w-screen-1.5xl mx-auto py-4 px-4 lg:px-8 text-sm breadcrumbs">
      <ul class="!whitespace-normal">
        <li v-if="category.cat_parent">
          {{ trField(category.cat_parent, "title") }}
        </li>
        <li>
          <Link :href="trRoute('category', { category: trField(category, 'url') })">
            {{ trField(category, "title") }}
          </Link>
        </li>
        <li>{{ trField(product, "title") }}</li>
      </ul>
    </div>
    <div class="container max-w-screen-1.5xl mx-auto px-4 pb-10 lg:px-8 grid grid-cols-1 gap-8 lg:grid-cols-4">
      <div class="col-span-3">
        <div ref="target" class="border-neutral-200 grid grid-cols-1 lg:grid-cols-2 bg-white border p-4 rounded-md">
          <div class="lg:pr-12">
            <ProductBadge
                :created-at="product.created_at"
                :price-vat="product.price_vat"
                :price-default-vat="product.price_default_vat"
                :discount-start="product.discount_start"
                :discount-end="product.discount_end"
                :banners="product.banners"
                :good-price="product.good_price"
                :campaign-label="product.campaign_label"
            />
            <div v-if="product.filename" class="flex">
              <div class="max-w-96 max-h-96 basis-96">
                <ZoomContent :zoom-target="700">
                  <template #content>
                    <ProductPicture
                        :image="product.filename"
                        :title="product.title"
                        size="500"
                    />
                  </template>
                  <template #zoomed-content>
                    <ProductPicture
                        :image="product.filename"
                        :title="product.title"
                        size="700"
                    />
                  </template>
                </ZoomContent>
              </div>
              <MagnifyingGlassIcon class="ml-2 w-6 h-6"/>
            </div>
            <NoImage v-else classes="max-w-96 max-h-96"/>
            <div v-if="product.filename" class="my-4 space-x-4 flex">
              <VueEasyLightbox
                  v-if="files && files.length > 0"
                  teleport="body"
                  :visible="visibleRef"
                  :imgs="files"
                  :index="indexRef"
                  @hide="onHide"
              />
              <template v-for="(img, index) in files" :key="index">
                <a
                    v-if="files && files.length > 0"
                    href="#"
                    class="w-20 border border-gray-200"
                    @click.prevent="openGallery(index)"
                >
                  <template
                      v-if="
                    img.type === 'small_src' && product.banners[0].small_src
                  "
                  >
                    <img
                        alt="banner"
                        class="banner"
                        :src="imageUrl(product.banners[0].small_src.filename)"
                    />
                  </template>
                  <template v-else>
                    <ProductPicture
                        :image="img.filename"
                        :title="product.title"
                        size="100"
                    />
                  </template>
                </a>
              </template>
            </div>

            <div v-if="product.active" class="flex justify-between text-base font-semibold space-x-2">
              <a
                  href="#"
                  :data-tooltip="__('Lisa võrdlusse')"
                  @click.prevent="addToCompare"
              >
                <CompareSvg class="w-4 h-4 inline-block mr-2"/>
                {{ __("Lisa võrdlusse") }}
              </a>
              <a
                  target="_blank"
                  rel="nofollow"
                  :href="trRoute('pdf.product', {product: product.id})"
              >
                <PrinterIcon class="w-4 h-4 inline-block mr-2"/>
                {{ __("PDF") }}
              </a>
              <a href="#" @click.prevent="showModal">
                <ShareIcon class="w-4 h-4 inline-block mr-2"/>
                {{ __("Jaga toodet") }}
              </a>
            </div>
          </div>
          <div>
            <a id="product"></a>
            <div class="p-4 flex justify-between">
              <ProductLogo :brand="product.brand"/>
              <EnergyLabel
                  v-if="product.energy_class" :product-class="product.class"
                  :energy-class="product.energy_class"/>
            </div>
            <h1 class="text-2xl font-semibold">{{ trField(product, "title") }}</h1>
            <h3 class="text-sm py-4">{{ product.code }}</h3>
            <p class="mb-8 text-base">{{ trField(product, "description") }}</p>
            <div class="block lg:hidden pb-4">
              <ProductActions :product="product" :cart-services="cartServices"/>
            </div>
            <h3 class="text-xl font-semibold">{{ __("Tehnilised andmed") }}</h3>
            <div class="divider m-1"></div>
            <table class="table text-base">
              <tbody>
              <template v-for="(field, idx) in fields" :key="idx">
                <tr v-if="field.content">
                  <th class="align-top w-1/2 pl-0 py-1">{{ trField(field, "name") }}</th>
                  <td class="align-top w-1/2 py-1" :class="{ codes: field.code === 'LISATARVIKUD' }">
                    <FieldValue :field="field"/>
                  </td>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
        <div
            v-if="
        product.long_description ||
        isLoadbee(product.brand) ||
        isFlixmedia(product.brand) ||
        isEstorecontent(product.brand)"
            class="pb-4"
        >
          <a id="description" class="block relative -top-12 lg:-top-24 invisible"></a>
          <h3 class="text-xl font-semibold my-6 border-b border-b-gray-300">
            {{ __("Tootja info") }}
          </h3>
          <div
              v-if="product.long_description"
              v-html="oembed(product.long_description)"
          >
          </div>
          <FlixMedia v-else-if="isFlixmedia(product.brand)" :product="product"/>
          <LoadBee v-else-if="isLoadbee(product.brand)" :product="product"/>
          <EstoreContent
              v-else-if="isEstorecontent(product.brand)"
              :product="product"
          />
        </div>

        <div v-if="product.related.length > 0" class="pb-4">
          <a id="related" class="block relative -top-12 lg:-top-24 invisible"></a>
          <h3 class="text-xl font-semibold my-6 border-b border-b-gray-300">
            {{ __("Kokkusobivad tooted") }}
          </h3>
          <AssociatedProductDisplay narrow :products="product.related" :compare="false"/>
        </div>
        <div v-if="product.add_ons.length > 0" class="pb-4">
          <a id="add-ons" class="block relative -top-12 lg:-top-24 invisible"></a>
          <h3 class="text-xl font-semibold my-6 border-b border-b-gray-300">
            {{ __("Lisatarvikud") }}
          </h3>
          <AssociatedProductDisplay narrow :products="product.add_ons" :compare="false"/>
        </div>
        <div v-if="similar.length > 0" class="pb-4">
          <a id="similar" class="block relative -top-12 lg:-top-24 invisible"></a>
          <h3 class="text-xl font-semibold my-6 border-b border-b-gray-300">
            {{ __("Sarnased tooted") }}
          </h3>
          <AssociatedProductDisplay narrow :products="similar"/>
        </div>
      </div>

      <div class="hidden lg:block">
        <div class="border-neutral-200 bg-white border rounded-md p-4 top-5 sticky">
          <ProductActions :product="product" :cart-services="cartServices"/>
        </div>
      </div>
    </div>

    <div v-if="recent.length > 0" class="hidden lg:block container max-w-screen-1.5xl px-8 lg:px-8 mx-auto pb-10">
      <h3 class="text-xl font-semibold mb-6 border-b border-b-gray-300">
        {{ __("Viimati vaadatud tooted") }}
      </h3>
      <AssociatedProductDisplay :products="recent"/>
    </div>
  </section>
</template>

<script setup>
import FlixMedia from "../components/FlixMedia.vue";
import LoadBee from "../components/LoadBee.vue";
import ShareModal from "../composables/ShareModal.vue";
import EstoreContent from "../components/EstoreContent.vue";
import {
  __,
  imageUrl,
  isEstorecontent,
  isFlixmedia,
  isLoadbee,
  oembed,
  trField,
  trRoute,
  useRoute
} from "../utils";
import AssociatedProductDisplay from "../composables/AssociatedProductDisplay.vue";
import ProductCompares from "../composables/ProductCompares.vue";
import ProductBadge from "../components/ProductBadge.vue";
import ZoomContent from "../components/ZoomContent.vue";
import ProductPicture from "../components/ProductPicture.vue";
import NoImage from "../components/NoImage.vue";
import {Head, Link, router} from "@inertiajs/vue3";
import {computed, ref} from "vue";
import VueEasyLightbox from "vue-easy-lightbox";
import FieldValue from "../components/FieldValue.vue";
import ProductLogo from "../components/ProductLogo.vue";
import CompareSvg from "../../images/elux-vordlus.svg";
import {PrinterIcon, ShareIcon, MagnifyingGlassIcon} from "@heroicons/vue/24/solid";
import ProductActions from "../composables/ProductActions.vue";
import EnergyLabel from "../components/EnergyLabel.vue";
import {useElementVisibility} from "@vueuse/core";
import ProductPrice from "../components/ProductPrice.vue";
import {getActiveLanguage} from "laravel-vue-i18n";

const props = defineProps({
  product: Object,
  similar: Array,
  cartServices: Array,
  category: Object,
  fields: Array,
  recent: Array
});

const target = ref(null);
const targetIsVisible = useElementVisibility(target);
const modalVisible = ref(false);
const showModal = () => (modalVisible.value = true);
const visibleRef = ref(false);
const indexRef = ref(0);
const files = computed(() => {
  let orderedFiles = [];
  if (props.product && props.product.files) {
    orderedFiles = [...props.product.files];
  }
  if (
      props.product.banners &&
      props.product.banners[0] &&
      props.product.banners[0].small_src
  ) {
    orderedFiles.push({
      ...props.product.banners[0].small_src,
      thumb: imageUrl(props.product.banners[0].small_src.filename),
      src: imageUrl(props.product.banners[0].small_src.filename)
    });
  }
  return orderedFiles;
});
const openGallery = (index) => {
  indexRef.value = index;
  visibleRef.value = true;
};
const onHide = () => (visibleRef.value = false);
const addToCompare = () =>
    router.put(trRoute("compare.update", {id: props.product.id}));
const shareUrl = trRoute("product", {product: trField(props.product, "url")});
</script>
